import { isString } from '@/utils/checks'
import React, { FC, ReactNode, MouseEventHandler } from 'react'

export interface LinkButtonProps {
  label: string
  href?: string
  iconElement?: ReactNode
  onClick?:
    | MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
    | (() => void | Promise<void>)
  className?: string
  underline?: 'always' | 'never' | 'hover'
  size?: 'small' | 'medium' | 'large'
}

const LinkButton: FC<LinkButtonProps> = ({
  label,
  href,
  iconElement,
  onClick = undefined,
  className = '',
  underline = 'hover',
  size = 'medium'
}) => {
  const isAnchorTag = isString(href)
  const Element = isAnchorTag ? 'a' : 'button'
  const elementProps = isAnchorTag ? { href } : { onClick }

  const textSize = {
    small: 'text-xs',
    medium: 'text-sm',
    large: 'text-base'
  }

  const textWeight = {
    small: 'font-normal',
    medium: 'font-semibold',
    large: 'font-medium'
  }

  const underlineClass = {
    always: 'underline',
    never: '',
    hover: 'hover:underline'
  }

  return (
    <Element
      className={`relative inline cursor-pointer ${textSize[size]} ${textWeight[size]} text-gray-1100 ${underlineClass[underline]} ${className}`}
      {...elementProps}
    >
      <span className="inline">{label}</span>
      <span className="inline-block align-middle">{iconElement}</span>
    </Element>
  )
}
export default LinkButton
